"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.person = exports.legalPerson = exports.naturalPerson = exports.naturalPersonNames = exports.dateAndPlaceOfBirth = exports.placeOfBirth = exports.dateOfBirth = exports.nationalIdentification = exports.registrationAuthority = exports.nationalIdentifier = exports.nationalIdentifierTypeCode = exports.geographicAddresses = exports.geographicAddress = exports.accountNumbers = exports.countryCode = exports.addressLine = exports.addressLineItem = exports.countrySubDivision = exports.districtName = exports.townLocationName = exports.townName = exports.room = exports.postCode = exports.postBox = exports.floor = exports.buildingName = exports.buildingNumber = exports.streetName = exports.subDepartment = exports.department = exports.addressCodeType = exports.legalPersonNameIdentifier = exports.legalPersonNameId = exports.legalPersonNameIdentifierType = exports.legalPersonName = exports.naturalPersonNameIdentifierWrapper = exports.personNameId = exports.secondaryIdentifier = exports.primaryIdentifier = exports.naturalPersonNameIdentifierType = exports.transactionBlockchainInfo = exports.txHash = exports.customerIdentification = exports.accountNumber = exports.transactionAmount = exports.address = exports.transactionAsset = exports.coingeckoIdAndNetworkAsset = exports.caip19Asset = exports.did = void 0;
exports.naturalOrLegalPersonGeographicAddress = exports.naturalOrLegalPersonDateAndPlaceOfBirth = exports.naturalOrLegalPersonNationalIdentification = exports.naturalOrLegalPersonCustomerIdentification = exports.naturalOrLegalPersonName = exports.ivms101 = exports.beneficiary = exports.originator = void 0;
const yup = __importStar(require("yup"));
const validationMessages_1 = require("./validationMessages");
exports.did = yup.string().matches(/did:[a-zA-Z0-9]*:.*$/);
exports.caip19Asset = yup.object().shape({
    caip19: yup.string(),
});
exports.coingeckoIdAndNetworkAsset = yup.object().shape({
    coingeckoId: yup.string(),
    network: yup.string(),
});
exports.transactionAsset = yup.lazy((value) => {
    if (value.caip19) {
        return exports.caip19Asset.required();
    }
    else if (value.coingeckoId) {
        return exports.coingeckoIdAndNetworkAsset.required();
    }
    return yup.string().required();
});
exports.address = yup.string();
exports.transactionAmount = yup.string().matches(/^\d+$/); // Only string numbers
exports.accountNumber = yup.string();
exports.customerIdentification = yup.string().matches(/^[ -~]{0,50}$/);
exports.txHash = yup.string();
exports.transactionBlockchainInfo = yup
    .object()
    .shape({
    txHash: exports.txHash,
    origin: exports.address,
    destination: exports.address.required(),
})
    .strict(true);
exports.naturalPersonNameIdentifierType = yup
    .string()
    .oneOf(['ALIA', 'BIRT', 'MAID', 'LEGL', 'MISC']);
exports.primaryIdentifier = yup
    .string()
    .matches(/^[ -~]{0,100}$/, validationMessages_1.validationMessages.alphanumeric(100))
    .max(100);
exports.secondaryIdentifier = yup
    .string()
    .matches(/^[ -~]{0,100}$/, validationMessages_1.validationMessages.alphanumeric(100))
    .max(100);
exports.personNameId = yup
    .object()
    .shape({
    primaryIdentifier: exports.primaryIdentifier.required(),
    secondaryIdentifier: exports.secondaryIdentifier,
    nameIdentifierType: yup.string(),
})
    .strict(true);
exports.naturalPersonNameIdentifierWrapper = yup
    .object({
    nameIdentifier: yup.array().of(exports.personNameId).required(),
    localNameIdentifier: yup.array().of(exports.personNameId),
    phoneticNameIdentifier: yup.array().of(exports.personNameId),
})
    .strict(true);
exports.legalPersonName = yup
    .string()
    .matches(/^[ -~]{0,100}$/, validationMessages_1.validationMessages.alphanumeric(100))
    .max(100);
exports.legalPersonNameIdentifierType = yup
    .string()
    .oneOf(['LEGL', 'SHRT', 'TRAD']);
exports.legalPersonNameId = yup
    .object({
    legalPersonName: exports.legalPersonName.required(),
    legalPersonNameIdentifierType: yup.string(),
})
    .strict(true);
exports.legalPersonNameIdentifier = yup
    .object({
    nameIdentifier: yup.array().of(exports.legalPersonNameId).required(),
    localNameIdentifier: yup.array().of(exports.personNameId),
    phoneticNameIdentifier: yup.array().of(exports.personNameId),
})
    .strict(true);
exports.addressCodeType = yup.string().oneOf(['HOME', 'BIZZ', 'GEOG']);
exports.department = yup.string().min(1).max(50);
exports.subDepartment = yup.string().min(1).max(70);
exports.streetName = yup.string().min(1).max(70);
exports.buildingNumber = yup.string().min(1).max(16);
exports.buildingName = yup.string().min(1).max(35);
exports.floor = yup.string().min(1).max(70);
exports.postBox = yup.string().min(1).max(16);
exports.postCode = yup.string().min(1).max(16);
exports.room = yup.string().min(1).max(70);
exports.townName = yup.string().min(1).max(35);
exports.townLocationName = yup.string().min(1).max(35);
exports.districtName = yup.string().min(1).max(35);
exports.countrySubDivision = yup.string().min(1).max(35);
exports.addressLineItem = yup
    .string()
    .matches(/^[ -~]{0,70}$/, validationMessages_1.validationMessages.alphanumeric(70));
exports.addressLine = yup.array().of(exports.addressLineItem);
exports.countryCode = yup
    .string()
    .matches(/^[A-Z]{2}$/, validationMessages_1.validationMessages.countryCode('SG'));
exports.accountNumbers = yup.array().min(1).of(exports.accountNumber);
exports.geographicAddress = yup
    .object()
    .shape({
    addressType: yup.string(),
    department: yup.string(),
    subDepartment: yup.string(),
    streetName: yup.string(),
    buildingNumber: yup.string(),
    buildingName: yup.string(),
    floor: yup.string(),
    postBox: yup.string(),
    postCode: yup.string(),
    room: yup.string(),
    townName: yup.string(),
    townLocationName: yup.string(),
    districtName: yup.string(),
    countrySubDivision: yup.string(),
    addressLine: yup.array().of(yup.string()),
    countryCode: yup.string(),
})
    .strict(true);
exports.geographicAddresses = yup.array().of(exports.geographicAddress);
exports.nationalIdentifierTypeCode = yup
    .mixed()
    .oneOf([
    'ARNU',
    'CCPT',
    'RAID',
    'DRLC',
    'FIIN',
    'TXID',
    'SOCS',
    'IDCD',
    'LEIX',
    'MISC',
]);
exports.nationalIdentifier = yup
    .string()
    .matches(/^[ -~]{0,35}$/, validationMessages_1.validationMessages.alphanumeric(35));
exports.registrationAuthority = yup
    .string()
    .matches(/^RA([0-9]{6})$/, validationMessages_1.validationMessages.format('RA123456'));
exports.nationalIdentification = yup
    .object({
    nationalIdentifier: yup.string().required(),
    nationalIdentifierType: yup.string().required(),
    countryOfIssue: yup.string(),
    registrationAuthority: yup.string(),
})
    .strict(true);
exports.dateOfBirth = yup
    .string()
    .matches(/^([0-9]{4})-([0-9]{2})-([0-9]{2})$/, validationMessages_1.validationMessages.format('YYYY-MM-DD'));
exports.placeOfBirth = yup
    .string()
    .matches(/^[ -~]{0,70}$/, validationMessages_1.validationMessages.alphanumeric(70));
exports.dateAndPlaceOfBirth = yup
    .object({
    dateOfBirth: yup.string().required(),
    placeOfBirth: yup.string().required(),
})
    .strict(true);
exports.naturalPersonNames = yup
    .array()
    .min(1)
    .of(exports.naturalPersonNameIdentifierWrapper);
exports.naturalPerson = yup
    .object({
    name: exports.naturalPersonNames.required(),
    geographicAddress: yup.array().of(exports.geographicAddress),
    nationalIdentification: exports.nationalIdentification.default(undefined),
    customerIdentification: yup.string(),
    dateAndPlaceOfBirth: exports.dateAndPlaceOfBirth.default(undefined),
    countryOfResidence: yup.string(),
})
    .strict(true);
exports.legalPerson = yup
    .object({
    name: exports.legalPersonNameIdentifier.required(),
    geographicAddress: yup.array().of(exports.geographicAddress),
    nationalIdentification: exports.nationalIdentification.default(undefined),
    customerIdentification: yup.string(),
    countryOfResidence: yup.string(),
})
    .strict(true);
exports.person = yup
    .object({
    naturalPerson: exports.naturalPerson.default(undefined),
    legalPerson: exports.legalPerson.default(undefined),
})
    .test({
    name: 'naturalPerson xor legalPerson',
    exclusive: true,
    message: 'naturalPerson xor legalPerson',
    test: (value) => {
        return !!(value.naturalPerson || value.legalPerson);
    },
})
    .strict(true);
exports.originator = yup
    .object({
    originatorPersons: yup.array().of(exports.person).required(),
    accountNumber: exports.accountNumbers,
})
    .strict(true);
exports.beneficiary = yup
    .object({
    beneficiaryPersons: yup.array().of(exports.person).required(),
    accountNumber: exports.accountNumbers,
})
    .strict(true);
exports.ivms101 = yup
    .object({
    beneficiary: exports.beneficiary,
    originator: exports.originator,
})
    .strict(true);
yup.addMethod(yup.object, 'naturalOrLegalPerson', function naturalOrLegalPerson() {
    return this.test({
        name: 'naturalPerson xor legalPerson',
        exclusive: true,
        message: 'naturalPerson xor legalPerson',
        test: (value) => {
            return !!(value.naturalPerson || value.legalPerson);
        },
    });
});
exports.naturalOrLegalPersonName = yup
    .array()
    .min(1)
    .of(yup
    .object({
    naturalPerson: yup
        .object({
        name: exports.naturalPersonNames.required(),
    })
        .default(undefined),
    legalPerson: yup
        .object({
        name: exports.legalPersonNameIdentifier.required(),
    })
        .default(undefined),
})
    .naturalOrLegalPerson());
exports.naturalOrLegalPersonCustomerIdentification = yup
    .array()
    .min(1)
    .of(yup
    .object({
    naturalPerson: yup
        .object({
        customerIdentification: exports.customerIdentification.required(),
    })
        .default(undefined),
    legalPerson: yup
        .object({
        customerIdentification: exports.customerIdentification.required(),
    })
        .default(undefined),
})
    .naturalOrLegalPerson());
exports.naturalOrLegalPersonNationalIdentification = yup
    .array()
    .min(1)
    .of(yup
    .object({
    naturalPerson: yup
        .object({
        nationalIdentification: exports.nationalIdentification.required(),
    })
        .default(undefined),
    legalPerson: yup
        .object({
        nationalIdentification: exports.nationalIdentification.required(),
    })
        .default(undefined),
})
    .naturalOrLegalPerson());
exports.naturalOrLegalPersonDateAndPlaceOfBirth = yup
    .array()
    .min(1)
    .of(yup
    .object({
    naturalPerson: yup
        .object({
        dateAndPlaceOfBirth: exports.dateAndPlaceOfBirth.required(),
    })
        .default(undefined),
    legalPerson: yup
        .object({
        dateAndPlaceOfBirth: exports.dateAndPlaceOfBirth.required(),
    })
        .default(undefined),
})
    .naturalOrLegalPerson());
exports.naturalOrLegalPersonGeographicAddress = yup
    .array()
    .min(1)
    .of(yup
    .object({
    naturalPerson: yup
        .object({
        geographicAddress: exports.geographicAddresses.required(),
    })
        .default(undefined),
    legalPerson: yup
        .object({
        geographicAddress: exports.geographicAddresses.required(),
    })
        .default(undefined),
})
    .naturalOrLegalPerson());
